/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_remove = /** @type {(inputs: {}) => string} */ () => {
	return `Odebrat`
};

const da_remove = /** @type {(inputs: {}) => string} */ () => {
	return `Fjern`
};

const de_remove = /** @type {(inputs: {}) => string} */ () => {
	return `Entfernen`
};

const en_remove = /** @type {(inputs: {}) => string} */ () => {
	return `Remove`
};

const es_remove = /** @type {(inputs: {}) => string} */ () => {
	return `Eliminar`
};

const fr_remove = /** @type {(inputs: {}) => string} */ () => {
	return `Retirer`
};

const hu_remove = /** @type {(inputs: {}) => string} */ () => {
	return `Eltávolítás`
};

const it_remove = /** @type {(inputs: {}) => string} */ () => {
	return `Rimuovi`
};

const nl_remove = /** @type {(inputs: {}) => string} */ () => {
	return `Verwijderen`
};

const pl_remove = /** @type {(inputs: {}) => string} */ () => {
	return `Usuń`
};

const pt_remove = /** @type {(inputs: {}) => string} */ () => {
	return `Remover`
};

const sv_remove = /** @type {(inputs: {}) => string} */ () => {
	return `Ta bort`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const remove = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.remove(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("remove", locale)
	if (locale === "cs") return cs_remove(inputs)
	if (locale === "da") return da_remove(inputs)
	if (locale === "de") return de_remove(inputs)
	if (locale === "en") return en_remove(inputs)
	if (locale === "es") return es_remove(inputs)
	if (locale === "fr") return fr_remove(inputs)
	if (locale === "hu") return hu_remove(inputs)
	if (locale === "it") return it_remove(inputs)
	if (locale === "nl") return nl_remove(inputs)
	if (locale === "pl") return pl_remove(inputs)
	if (locale === "pt") return pt_remove(inputs)
	return sv_remove(inputs)
};